class CartCount extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return
    if (!state.sections) return

    if (!('push-cart-count' in state.sections)) return

    const newCartTotal = parseInt(
      this.getCount(state.sections['push-cart-count']),
    )

    this.setAttribute('aria-hidden', newCartTotal === 0)

    if (this.els?.amount?.element) {
      this.els.amount.element.textContent = this.getCount(
        state.sections['push-cart-count'],
      )
    } else {
      this.textContent = this.getCount(state.sections['push-cart-count'])
    }

    this.updateAriaLabel(newCartTotal)
  }

  /**
   * Update the aria-label attribute of the header mini cart element for ADA compliance
   *
   * @param {int} count
   * @returns {void}
   */
  updateAriaLabel (count) {
    const element = document.getElementById('header-mini-cart')
    if (!element) return

    const srLabel = element.querySelector('[data-cart-count-label]')
    if (!srLabel) return

    const countTemplate =
      count === 1
        ? srLabel.dataset.cartCountOne
        : srLabel.dataset.cartCountOther
    const countLabel = countTemplate.replace('__COUNT__', count)
    const ariaLabel = `${srLabel.dataset.cartLabel}: ${countLabel}`
    element.setAttribute('aria-label', ariaLabel)
    srLabel.textContent = ariaLabel
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
